// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"1":"408a0f98","156":"437f5a74","171":"21e3ceb7","476":"b1dae70f","767":"ed3e60cb"}[chunkId] + ".js";
};